<template>
    <loader v-if="$store.state.stats.loading" />
    <div v-else>
        <sales-pivot
            defaultSort="avgLead"
            :dataObject="groupedByUserAndCampaign"
            :fields="$store.state.main.standardSalesPivotOptions.fields"
            :nestedFields="$store.state.main.standardSalesPivotOptions.nestedFields"
            :valueFunctions="$store.state.main.standardSalesPivotOptions.valueFunctions" />
    </div>
</template>

<script>
import SalesPivot from '@/components/salesPivot.vue'

export default {
    components: {
        SalesPivot
    },
	data() {
		return {
			groupedByUserAndCampaign: null
		};
	},
	computed: {
		team() {
			return this.$store.state.main.team;
		},
		storeUsers() {
			return this.$store.state.main.users;
		},
		range() {
			return this.$store.state.stats.range;
		},
        campaignMap() {
            return this.$store.state.main.campaignMap
        },
        excludeWinback() {
            return this.$store.state.stats.excludeWinback
        },
        excludeInactive() {
            return this.$store.state.stats.excludeInactive
        }
	},
	methods: {
		async getData() {
            this.$store.commit('stats/startLoading')
            let team, department
            if (this.team === 'Alle teams') {
                team = null
            } else if (this.team === 'Tryg') {
                department = 'tryg'
            } else if (this.team === 'Alka') {
                department = 'alka'
            } else {
                team = this.team
            }
			let response = await this.$http().get("/stats/agents",
				{
					params: {
						from: this.range[0],
						to: this.range[1],
                        team: team,
                        department: department,
                        excludeWinback: this.excludeWinback,
                        excludeInactive: this.excludeInactive
					}
				}
			);
            this.groupedByUserAndCampaign = response.data;
            this.$store.commit('stats/setTotals', this.$reduceNested(this.groupedByUserAndCampaign, this.$store.state.main.standardSalesPivotOptions.nestedFields))
            this.$store.commit('stats/stopLoading')
		}
	},
	watch: {
		team: function() {
			this.getData();
		},
		storeUsers: function() {
			this.getData();
		},
		range: {
			handler({ length }) {
                if (length === 2) this.getData();
			},
			deep: true
		},
        excludeWinback: function() {
            this.getData()
        },
        excludeInactive: function() {
            this.getData()
        }
	},
	created() {
        if (this.storeUsers && !this.groupedByUserAndCampaign) {
		    this.getData();
        }
	}
};
</script>